import { AVAILABLE_STATE } from "constants/driveEntryState";
import type { OrchidDriveDirectory } from "contexts/orchid-drive/types";

export function isDriveDirectoryNotifyAvailable(
  entry: OrchidDriveDirectoryNotify,
) {
  return !entry.deleted_datetime && entry.directory_status === AVAILABLE_STATE;
}

export function isDriveDirectoryAvailable(entry: OrchidDriveDirectory) {
  return !entry.deletedDatetime && entry.directoryStatus === AVAILABLE_STATE;
}
